<template>
  <div id="sidenav-app" class="sidenav">
    <a href="javascript:void(0)" class="closebtn" @click="closeNav()">&times;</a>
    <router-link class="nav-link" tabindex="-1" to="/content">{{ $t("MENU.CONTENTS") }}</router-link>
    <router-link class="nav-link" tabindex="-1" to="/shop" v-if="$store.getters.getData.is_shop">{{ $t("MENU.SHOP") }}</router-link>
    <router-link class="nav-link" tabindex="-1"  to="/cart" v-if="$store.getters.getData.is_shop">{{ $t("MENU.CART") }}</router-link>
    <router-link class="nav-link" tabindex="-1"  to="/settings">{{ $t("MENU.SETTINGS") }}</router-link>
    <router-link class="nav-link" tabindex="-1" to="/search">{{ $t("MENU.SEARCH") }}</router-link>
  </div>
</template>

<script>

export default {
  name: 'SiteMenu',
  methods: {
    closeNav: function () {
      document.getElementById('sidenav-app').style.width = '0'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
/* The side navigation menu */
.sidenav
  height: 100%; ///* 100% Full-height */
  width: 0; ///* 0 width - change this with JavaScript */
  position: fixed; ///* Stay in place */
  z-index: 100; ///* Stay on top */
  top: 0; ///* Stay at the top */
  left: 0;
  // background-color: #111; ///* Black*/
  background-color: rgba(0, 0, 0, 0.95);
  overflow-x: hidden; ///* Disable horizontal scroll */
  padding-top: 60px; ///* Place content 60px from the top */
  transition: 0.5s; // /* 0.5 second transition effect to slide in the sidenav */

/* The navigation menu links */
.sidenav a
  padding: 8px 12px 8px 32px;
  text-decoration: none;
  font-size: 1.7rem
  color: #818181;
  display: block;
  transition: 0.3s;

/* When you mouse over the navigation links, change their color */
.sidenav a:hover
    color: #f1f1f1;

/* Position and style the close button (top right corner) */
.sidenav .closebtn
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 2.5rem
  margin-left: 50px;

.nav-link
  outline: none;

/* On smaller screens, where height is less than 450px, change the style of the sidenav (less padding and a smaller font size) */
@media screen and (max-height: 450px)
  .sidenav
    padding-top: 15px;
  .sidenav a
    font-size: 18px;
</style>



// WEBPACK FOOTER //
// src/components/SideMenu.vue